import { ListActionFactory } from '../../../shared/utils/redux/list/list.actions'
import { DailyReportColumnDto } from '../../../shared/remote-services/dtos/dailyReportColumn.dto'

export class DailyReportColumnsActions {
  public static loadDailyReportColumns = new ListActionFactory<
    DailyReportColumnDto,
    void
  >('[CORE] LOAD DAILY REPORT COLUMNS')
}
